
import { Check, X, Sparkles, Brain, Workflow, Code2, FileCode2 } from "lucide-react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

interface ComparisonFeature {
  text: string;
  icon: React.ReactNode;
}

const features: ComparisonFeature[] = [{
  text: "Eliminates repetitive context explanations",
  icon: <Brain className="w-5 h-5 text-primary inline-block mr-2" />
}, {
  text: "Preserves architectural decisions between sessions",
  icon: <FileCode2 className="w-5 h-5 text-primary inline-block mr-2" />
}, {
  text: "Prevents project rebuilding due to AI memory loss",
  icon: <Code2 className="w-5 h-5 text-primary inline-block mr-2" />
}, {
  text: "AI-enhanced tasks with pre-loaded context",
  icon: <Workflow className="w-5 h-5 text-primary inline-block mr-2" />
}, {
  text: "Maintains consistent coding outcomes",
  icon: <Sparkles className="w-5 h-5 text-primary inline-block mr-2" />
}];

const ComparisonSection = () => {
  return <section className="section-padding bg-[#113C69] relative overflow-hidden" style={{
    backgroundImage: `url('https://ideybnueizkxwqmjowpy.supabase.co/storage/v1/object/sign/coderide-website/cr_bg_2.webp?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1cmwiOiJjb2RlcmlkZS13ZWJzaXRlL2NyX2JnXzIud2VicCIsImlhdCI6MTc0NDk2MTQwNywiZXhwIjoxNzc2NDk3NDA3fQ.IfeUNJDzKofonFVKJ4W7xXhMNEFh392WSjUZ98qCVXs')`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat'
  }}>
      <div className="absolute inset-0 bg-coderide-black/50 backdrop-blur-sm"></div>
      <div className="container relative z-10">
        <h2 className="text-2xl md:text-3xl font-bold text-center mb-4 text-white bg-gradient-to-r from-white to-white/70 bg-clip-text">
          Addressing the Painpoints of Your Vibe Coding
        </h2>
        <p className="text-center text-white/70 mb-12 max-w-3xl mx-auto text-base">
          See how CodeRide solves the <span className="bg-[#7867EE] text-white px-2 py-1 rounded font-mono">common frustrations</span> <strong className="font-semibold text-white">vibe coders and developers</strong> face with AI coding agents.{" "}
          <button 
            onClick={() => window.location.href = '/pricing'}
            className="inline-flex items-center text-base font-bold text-coderide-light-blue hover:text-white transition-colors"
          >
            <span className="underline">View pricing plans</span> →
          </button>
        </p>
        
        <div className="max-w-4xl mx-auto">
          <div className="rounded-2xl overflow-hidden border border-white/10 bg-[#F5F5F5]/5 backdrop-blur-md shadow-2xl">
            <div className="relative w-full overflow-auto">
              <Table className="min-w-[640px]">
                <TableHeader>
                <TableRow className="hover:bg-transparent border-white/10">
                  <TableHead className="w-[60%] text-white/90 font-semibold text-xs sm:text-sm md:text-lg whitespace-nowrap">FEATURE</TableHead>
                  <TableHead className="text-center w-[20%] text-white/90 font-semibold text-xs sm:text-sm md:text-lg whitespace-nowrap">
                    CodeRide
                  </TableHead>
                  <TableHead className="text-center w-[20%] text-white/90 font-semibold text-xs sm:text-sm md:text-lg whitespace-nowrap">
                    Other AI Tools
                  </TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {features.map((feature, index) => (
                  <TableRow key={index} className="hover:bg-white/5 transition-all duration-300 border-white/10">
                    <TableCell className="font-medium text-white/90 flex items-center">
                      {feature.icon}
                      {feature.text}
                    </TableCell>
                    <TableCell className="text-center">
                      <div className="flex justify-center">
                        <div className="bg-gradient-to-r from-[#53CADE] to-[#113C89] p-2 rounded-full">
                          <Check className="h-4 w-4 text-white" />
                        </div>
                      </div>
                    </TableCell>
                    <TableCell className="text-center">
                      <div className="flex justify-center">
                        <div className="bg-red-500/20 p-2 rounded-full border border-red-500/30">
                          <X className="h-4 w-4 text-red-500" />
                        </div>
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            </div>
          </div>
        </div>
      </div>
    </section>;
};

export default ComparisonSection;
